module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.fails.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.fails.js
// module chunks = 0